/**
 * Blog post banner — article audio player (play/pause, progress, duration).
 */
(function () {
  'use strict';

  function formatTime(seconds) {
    if (!isFinite(seconds) || seconds < 0) return '0:00';
    var mins = Math.floor(seconds / 60);
    var secs = Math.floor(seconds % 60);
    return mins + ':' + (secs < 10 ? '0' : '') + secs;
  }

  function initPlayer(root) {
    var audio = root.querySelector('[data-blog-banner-audio]');
    var toggle = root.querySelector('[data-blog-banner-audio-toggle]');
    var progress = root.querySelector('[data-blog-banner-audio-progress]');
    var progressFill = root.querySelector('[data-blog-banner-audio-progress-fill]');
    var currentEl = root.querySelector('[data-blog-banner-audio-current]');
    var durationEl = root.querySelector('[data-blog-banner-audio-duration]');

    if (!audio || !toggle) return;

    function syncDuration() {
      if (durationEl) {
        durationEl.textContent = formatTime(audio.duration);
      }
      if (progress && isFinite(audio.duration)) {
        progress.max = Math.floor(audio.duration) || 100;
      }
    }

    function syncProgress() {
      if (currentEl) {
        currentEl.textContent = formatTime(audio.currentTime);
      }
      if (progress && isFinite(audio.duration) && audio.duration > 0) {
        progress.value = Math.floor(audio.currentTime);
        var pct = (audio.currentTime / audio.duration) * 100;
        if (progressFill) {
          progressFill.style.width = pct + '%';
        }
        progress.style.setProperty('--progress', pct + '%');
      }
    }

    toggle.addEventListener('click', function () {
      if (audio.paused) {
        document.querySelectorAll('[data-blog-banner-audio]').forEach(function (other) {
          if (other !== audio && !other.paused) {
            other.pause();
            var otherRoot = other.closest('[data-blog-post-banner-audio]');
            if (otherRoot) {
              var otherToggle = otherRoot.querySelector('[data-blog-banner-audio-toggle]');
              if (otherToggle) otherToggle.classList.remove('is-playing');
            }
          }
        });
        audio.play();
        toggle.classList.add('is-playing');
      } else {
        audio.pause();
        toggle.classList.remove('is-playing');
      }
    });

    audio.addEventListener('loadedmetadata', syncDuration);
    audio.addEventListener('durationchange', syncDuration);
    audio.addEventListener('timeupdate', syncProgress);
    audio.addEventListener('ended', function () {
      toggle.classList.remove('is-playing');
      syncProgress();
    });

    if (progress) {
      progress.addEventListener('input', function () {
        audio.currentTime = Number(progress.value);
        syncProgress();
      });
    }

    syncDuration();
    syncProgress();
  }

  function init() {
    document.querySelectorAll('[data-blog-post-banner-audio]').forEach(initPlayer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
